import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Grid,
  Box,
  IconButton,
  useMediaQuery,
  Chip,
  Snackbar,
  SnackbarContent,
  Alert,
  Modal,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowBackIos, ArrowForwardIos, Star } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { useFetch } from "../../hooks";
import { useLocation } from "react-router-dom";
import configureStore from "../../store";
import {
  addToCart,
  addProductToStore,
  setModalProperties,
  updateCartQuantity,
  removeFromCart,
} from "../../store/actions/userActions";

// Product Card Component

const ProductCard = ({ product, onItemAdded, onImageClick }) => {
  const [count, setCount] = useState(1);
  const [isAdded, setIsAdded] = useState(false);
  const [buttonColor, setButtonColor] = useState("#038100");
  const [showProductZoomModal, setShowProductZooModal] = useState();
  const { store, persistor } = configureStore();
  const dispatch = useDispatch();

  const handleAdd = () => {
    setCount(1);
    onItemAdded(
      product.title,
      product.price,
      product.discount,
      product.image,
      1
    );
    setButtonColor("#ff9800");
  };
  const increaseItem1 = (item) => {
    console.log("productpage inc item", item);
    const newQuantity = count + 1;
    setCount(newQuantity);
    const productId = item?.vlisting_id?.toString() || "0";
    dispatch(updateCartQuantity(productId, newQuantity));
  };

  const decreaseItem1 = (item) => {
    const productId = item?.vlisting_id?.toString();
    const currentQty = count;

    if (currentQty > 1) {
      const newQuantity = currentQty - 1;
      setCount(newQuantity);

      dispatch(updateCartQuantity(productId, newQuantity));
    } else if (currentQty === 1) {
      setIsAdded(false);
      dispatch(removeFromCart(productId));
    }
  };

  const increaseItem = (item) => {
    const maxStock = item?.quantity || 999;
    if (count >= maxStock) {
      dispatch(
        setModalProperties({
          showModal: true,
          modalMessage: `Cannot add more. Only ${maxStock} items available in stock.`,
        })
      );
      return;
    }

    const newQuantity = count + 1;
    setCount(newQuantity);

    // Use vlisting_id for listing products
    const productId = item?.vlisting_id?.toString() || "0";
    console.log("productId listing", productId);

    dispatch(updateCartQuantity(productId, newQuantity));
  };

  const decreaseItem = (item) => {
    const productId = item?.vlisting_id?.toString() || "0";

    if (count > 1) {
      const newQuantity = count - 1;
      setCount(newQuantity);
      dispatch(updateCartQuantity(productId, newQuantity));
    } else if (count === 1) {
      setIsAdded(false);
      dispatch(removeFromCart(productId));
    }
  };

  //      const increaseItem = (cartItem) => {
  //   const newQuantity = cartItem.quantity + 1;
  //   setCount(newQuantity);
  //   const id = cartItem.vlisting_id?.toString();
  //   dispatch(updateCartQuantity(id, newQuantity));
  // };

  // const decreaseItem = (cartItem) => {
  //   if (cartItem.quantity > 1) {
  //     const newQuantity = cartItem.quantity - 1;
  //     setCount(newQuantity);
  //     const id = cartItem.vlisting_id?.toString();
  //     dispatch(updateCartQuantity(id, newQuantity));
  //   } else if (cartItem.quantity === 1) {
  //     setIsAdded(false);
  //     dispatch(removeFromCart(cartItem.vlisting_id?.toString()));
  //   }
  // };

  const addProductToCart2 = (buttonType = "", product) => {
    const state = store.getState();
    const existingCartData = state.user?.cartDetails?.items || [];

    const id = product?.product_id
      ? product.product_id.toString()
      : product?.vlisting_id?.toString();

    const newItem = {
      product_id: id,
      vendor_id: product?.vendor_id?.toString() || "0",
      title: product?.name || "",
      quantity: 1,
      price: parseFloat(product?.price || "0.00").toFixed(2),
      discount: product?.discount || 0,
      additionalProducts: [],
      images: product?.images?.map((img) => img.image_url) || [],
      vlisting_id: product?.vlisting_id?.toString(),
    };

    // Create a new items array immutably:
    const updatedItems = existingCartData.map((item) => ({ ...item }));

      console.log("updatedItem",updatedItems);
    // Find matching item by *both* possible IDs:
    const index = updatedItems.findIndex(
      (item) =>
        (item.vlisting_id && item.vlisting_id === newItem.vlisting_id) ||
        item.product_id === newItem.product_id
    );

    if (index !== -1) {
      // Update quantity immutably
      const existing = updatedItems[index];
      updatedItems[index] = {
        ...existing,
        quantity: existing.quantity + 1,
      };
    } else {
      updatedItems.push(newItem);
    }

    const total = updatedItems.reduce(
      (sum, i) => sum + parseFloat(i.price) * (i.quantity || 1),
      0
    );

    dispatch(addToCart({ item: updatedItems, modification: false }));

    const itemList = updatedItems.map((i) => `• ${i.title}`).join("\n");

    dispatch(
      setModalProperties({
        showModal: true,
        modalMessage: `${updatedItems.length} ${
          updatedItems.length === 1 ? "item" : "items"
        } added to cart:\n${itemList}\n\nTotal: ₹${total.toFixed(2)}`,
      })
    );

    if (buttonType === "Buy") {
      // navigate("/checkoutpage");
    }
  };

  const addProductToCart = (buttonType = "", product) => {
    const state = store.getState();
    const existingCartData = state.user?.cartDetails?.items || [];

    console.log("listing product selected", product, existingCartData);

    // For listing products, use vlisting_id
    const productId = product?.vlisting_id?.toString() || "0";

    const productIndex = existingCartData.findIndex(
      (item) => item.vlisting_id === productId || item.product_id === productId
    );
    if (productIndex > -1) {
      console.log("Item already in cart, not adding again");
      setCount(existingCartData[productIndex].quantity);
      setIsAdded(true);
      return;
    }
    // Item doesn't exist, proceed to add
    const vendorId = product?.vendor_id?.toString() || "0";
    const productTitle = product?.name || "";
    const productPrice = product?.price || "0.00";
    const productDiscount = product?.discount || 0;
    const productImages = product?.images?.map((img) => img.image_url) || [];
    const maxQuantity = product?.quantity || 999;

    const newItem = {
      product_id: productId,
      vlisting_id: productId,
      vendor_id: vendorId,
      title: productTitle,
      quantity: 1,
      price: parseFloat(productPrice).toFixed(2),
      discount: productDiscount,
      additionalProducts: [],
      images: productImages,
      max_quantity: maxQuantity,
    };

    // Clone existing cart and add new item
    const existingCart = [...existingCartData, newItem];

    console.log("existingCart after adding new item", existingCart);

    // Set count to 1 for new item
    setCount(1);
    setIsAdded(true);
    const totalAmount = existingCart.reduce(
      (sum, item) => sum + parseFloat(item.price) * item.quantity,
      0
    );

    console.log("Final Cart State:", existingCart);
    console.log("Total: ₹", totalAmount.toFixed(2));

    dispatch(addToCart({ item: existingCart, modification: false }));
    const itemList = existingCart.map((item) => `• ${item.title}`).join("\n");

    // Show modal
    dispatch(
      setModalProperties({
        showModal: true,
        modalMessage: `${existingCart.length} ${
          existingCart.length === 1 ? "item" : "items"
        } in cart:\n${itemList}\n\nTotal: ₹${totalAmount.toFixed(2)}`,
      })
    );

    if (buttonType === "Buy") {
      // navigate("/checkoutpage");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        height: "100%",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 8px 16px rgba(0,0,0,0.12)",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          backgroundColor: "#f5f5f5",
          padding: "12px",
        }}
      >
        {/* <Chip
          label={discount}
          size="small"
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "#e53935",
            color: "white",
            fontWeight: "bold",
            fontSize: "0.7rem",
          }}
        /> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "140px",
            overflow: "hidden",
          }}
        >
          {/* Display the product image */}
          {/* {product.images?.length > 0 && ( 
            <img
              src={product.images?.[0]["image_url"]}
              alt={product.title}
              style={{
                maxHeight: "85%",
                maxWidth: "85%",
                objectFit: "contain",
              }}
              onClick={()=>{
                console.log("clikced on product",product);
                setShowProductZooModal(true)
              }}
            />
          )}  */}

          {product.images?.length > 0 &&
            product.images.map(
              (img, index) =>
                index === 0 && (
                  <img
                    key={index}
                    src={img.image_url}
                    alt={product.title}
                    style={{
                      maxHeight: "85%",
                      maxWidth: "85%",
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                    onClick={() => onImageClick(product, index)}
                  />
                )
            )}
        </Box>
      </Box>

      <Box
        sx={{
          padding: "12px 16px",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            fontSize: "0.75rem",
            lineHeight: 1.3,
            mb: 0.5,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 6,
            WebkitBoxOrient: "vertical",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            minHeight: `calc(0.75rem * 1.3 * 6)`,
          }}
        >
          {product.name}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#666",
            mb: 1,
            fontWeight: 500,
            fontSize: "0.75rem",
          }}
        >
          {Number.parseFloat(product.quantity)} units in stock
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#388e3c",
              color: "white",
              borderRadius: "4px",
              padding: "0px 4px",
              display: "flex",
              alignItems: "center",
              fontSize: "0.7rem",
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: 600, mr: 0.3 }}>
              {/* {product.rating} */}
              4.1
            </Typography>
            <Star sx={{ fontSize: "0.8rem" }} />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {!isAdded ? (
              <Button
                variant="outlined"
                sx={{
                  width: { xs: "100px", sm: "90px" },
                  color: buttonColor,
                  borderColor: buttonColor,
                  fontSize: "14px",
                  fontWeight: "bold",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "#FF6F00",
                    color: "#FF6F00",
                  },
                  "&:disabled": {
                    color: "#9e9e9e",
                    borderColor: "#9e9e9e",
                  },
                }}
                // onClick={() => addProductToCart("", product)}
                onClick={() => {
                  setIsAdded(true);
                  addProductToCart("", product);
                }}
                disabled={product.quantity <= 0}
              >
                Add
              </Button>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #038100",
                  borderRadius: "5px",
                  overflow: "hidden",
                }}
              >
                <IconButton
                  sx={{ color: "#038100", padding: "4px 8px" }}
                  onClick={() => decreaseItem(product)}
                >
                  <RemoveIcon />
                </IconButton>
                <Typography
                  sx={{
                    padding: "4px 16px",
                    backgroundColor: "#038100",
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {count}
                </Typography>
                <IconButton
                  sx={{ color: "#038100", padding: "4px 8px" }}
                  onClick={() => increaseItem(product)}
                >
                  <AddIcon />
                </IconButton>
              </Box>
            )}
          </Box>
        </Box>
        <Box sx={{ mt: "auto", display: "flex", alignItems: "baseline" }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1rem",
              color: "#000",
              mr: 1,
            }}
          >
            ₹{Number.parseFloat(product.price).toFixed(2)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const ListingProductList = ({ shop: shopProp }) => {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const dispatch = useDispatch();
  const latitude = useSelector(
    (state) => state.user?.userLocation?.latitude ?? null
  );
  const longitude = useSelector(
    (state) => state.user.userLocation?.longitude ?? null
  );
  const { slug } = useParams();
  const slug_id = slug ? slug.split("-").pop() : undefined;
   console.log("Extracted ID from slug:", slug_id);
  const { state } = useLocation();
  const [vendors, setVendors] = useState([]);
  const apptoken = useSelector((state) => state.user.apptoken);
  const shop = shopProp || (state?.shop
    ? state.shop
    : products.find((v) => String(v.id) === String(slug_id)));
 console.log("Listing shopDetails shop", shop);
  const vendorProductsUrl =
    shop?.id
      ? `${BASE_URL_TEST}/api/vlisting/all?vendor_id=${shop.id}`
      : null;
  const {
    data: vendorProductsData,
    isLoading: isVendorProductsLoading,
    error,
    fetchData,
  } = useFetch(vendorProductsUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (apptoken && shop?.id) {
      fetchData();
    }
  }, [apptoken, shop?.id, latitude, longitude]);

  useEffect(() => {
    if (vendorProductsData?.data) {
      // Filter only Listing products with status === 1
      const activeProducts = vendorProductsData.data
        .filter((item) => item.status === 1)
        .map((item) => ({
          ...item,
          title: item.name,
          id:item.vendor_id,
          quantity: item.quantity,
          price: item.price,
          discount: `${Math.round(item.discount)}%`,
          rating: item.rating ?? 4.5,
          image: item.images?.slice(0, 3).map((img) => img.image_url) || [],
        }));
      setProducts(activeProducts);
    } else {
      setProducts([]);
    }
  }, [vendorProductsData]);

  const [cartPopup, setCartPopup] = useState({
    open: false,
    item: "",
    price: 0,
    saved: 0,
    count: 0,
  });

  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const isSmallScreen = useMediaQuery("(max-width:767px)");
  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth * 0.75;
      scrollRef.current.scrollTo({
        left:
          direction === "left"
            ? scrollLeft - scrollAmount
            : scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };
  const handleItemAdded = (
    title,
    price,
    originalPrice,
    discount,
    image,
    quantity
  ) => {
    const numericPrice = parseFloat(price) || 0;
    const originalAmountprice = parseFloat(originalPrice) || 0;
    const numericQuantity = parseInt(quantity, 10) || 0;
    setCartPopup({
      open: true,
      item: title,
      price: numericPrice,
      image: image[0],
      count: numericQuantity,
    });

    setCart((prevCart) => [
      ...prevCart,
      {
        title,
        price: numericPrice,
        originalPrice: originalAmountprice,
        image: image[0],
        count: numericQuantity,
      },
    ]);

    dispatch(addProductToStore(cart));
  };

  // Modal popup state & handlers for product detail modal
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [clickedImageIndex, setClickedImageIndex] = useState(0);

  const handleImageClick = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedProduct(null);
  };

  // Modal component for product detail with images carousel
  const ProductDetailModal = ({ open, onClose, product, initialIndex }) => {
    const [currentImgIndex, setCurrentImgIndex] = useState(initialIndex || 0);

    if (!product) return null;

    const images = product.images || [];

    const handlePrev = () => {
      setCurrentImgIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const handleNext = () => {
      setCurrentImgIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };
    return (
      <>
        {selectedProduct && (
          <Modal open={open} onClose={onClose}>
            <Box
              sx={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90%", sm: "70%", md: "50%" },
                bgcolor: "background.paper",
                boxShadow: 24,
                borderRadius: "12px",
                display: "flex",
                p: 4,
                outline: "none",
                maxHeight: "80vh",
              }}
            >
              {/* Left side: image carousel */}
              <Box
                sx={{
                  width: "60%",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {images[currentImgIndex] ? (
                  <>
                    <IconButton
                      onClick={handlePrev}
                      sx={{
                        position: "absolute",
                        left: 0,
                        top: "50%",
                        transform: "translateY(-50%)",
                        bgcolor: "rgba(0,0,0,0.3)",
                        color: "white",
                        zIndex: 10,
                      }}
                    >
                      <ArrowBackIos />
                    </IconButton>

                    <img
                      src={images[currentImgIndex].image_url}
                      alt={`${product.name} ${currentImgIndex + 1}`}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "80vh",
                        borderRadius: "8px",
                        objectFit: "contain",
                      }}
                    />

                    <IconButton
                      onClick={handleNext}
                      sx={{
                        position: "absolute",
                        right: 0,
                        top: "50%",
                        transform: "translateY(-50%)",
                        bgcolor: "rgba(0,0,0,0.3)",
                        color: "white",
                        zIndex: 10,
                      }}
                    >
                      <ArrowForwardIos />
                    </IconButton>
                  </>
                ) : (
                  <Typography>No images available</Typography>
                )}
              </Box>

              {/* Right side: product details */}
              <Box
                sx={{
                  flex: 1,
                  pl: 3,
                  overflowY: "auto",
                  maxHeight: "80vh",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography variant="h6" fontWeight="bold" mb={2}>
                  {selectedProduct.name}
                </Typography>

                <Typography variant="h5" color="primary" mb={1}>
                  ₹{selectedProduct.price}
                </Typography>

                <Box sx={{ mt: "auto" }}>
                  <Button variant="contained" onClick={onClose}>
                    Close
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        )}
      </>
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        overflow: "hidden",
        padding: "2rem 0",
        backgroundColor: "#f0f2",
      }}
    >
      {products.length > 0 ? (
        <>
          {/* Section Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingX: { xs: 2.5, md: 4 },
              marginBottom: "1.5rem",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.75rem" },
                fontWeight: 700,
                color: "#333",
                position: "relative",
                "&:after": {
                  content: '""',
                  position: "absolute",
                  bottom: "-8px",
                  left: 0,
                  width: "60px",
                  height: "3px",
                  backgroundColor: "#4caf50",
                  borderRadius: "2px",
                },
              }}
            >
              Products Available
            </Typography>
          </Box>

          {/* Left Arrow */}
          <IconButton
            onClick={() => scroll("left")}
            sx={{
              position: "absolute",
              left: "8px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#333",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 2,
              boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
              display: { xs: "none", sm: "flex" },
              width: "40px",
              height: "40px",
            }}
          >
            <ArrowBackIos sx={{ fontSize: "1rem", ml: 1 }} />
          </IconButton>

          {/* Product Carousel */}
          <Box
            ref={scrollRef}
            sx={{
              display: "flex",
              overflowX: "auto",
              scrollBehavior: "smooth",
              gap: "16px",
              paddingX: { xs: 2.5, md: 4 },
              paddingBottom: 2,
              "&::-webkit-scrollbar": { display: "none" },
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            }}
          >
            {products.map((product, index) => (
              <Box
                key={index}
                sx={{
                  flex: "0 0 auto",
                  width: {
                    xs: "calc(100% - 32px)",
                    sm: "calc(50% - 24px)",
                    md: "calc(33.33% - 24px)",
                    lg: "calc(15% - 20px)",
                  },
                  minWidth: "200px",
                  maxWidth: "240px",
                }}
              >
                <ProductCard
                  product={product}
                  onItemAdded={handleItemAdded}
                  onImageClick={(index) => handleImageClick(product)}
                />
                {/* Product Detail Modal */}
                {selectedProduct && (
                  <ProductDetailModal
                    open={modalOpen}
                    onClose={handleCloseModal}
                    product={selectedProduct}
                  />
                )}
              </Box>
            ))}
          </Box>

          {/* Right Arrow */}
          <IconButton
            onClick={() => scroll("right")}
            sx={{
              position: "absolute",
              right: "8px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#333",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 2,
              boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
              display: { xs: "none", sm: "flex" },
              width: "40px",
              height: "40px",
            }}
          >
            <ArrowForwardIos sx={{ fontSize: "1rem" }} />
          </IconButton>
        </>
      ) : (
        <Box
          sx={{
            padding: "2rem",
            textAlign: "center",
            color: "#888",
            fontSize: "1rem",
            fontWeight: 700,
          }}
        >
          No products available.
        </Box>
      )}
      {cartPopup.open && (
        <Box
          sx={{
            position: "fixed",
            bottom: "16px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
            padding: "16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            maxWidth: "800px",
            zIndex: 1300,
          }}
        >
          {/* Product Image */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginRight: "16px",
              backgroundColor: "#f9f9f9",
              borderRadius: "8px",
              display: "none",
              padding: "8px",
              justifyContent: "center",
              width: { xs: "85px", sm: "100px" },
              height: { xs: "85px", sm: "120px" },
            }}
          >
            <CardMedia
              component="img"
              sx={{
                width: "80px",
                height: "80px",
                objectFit: "contain",
                borderRadius: "8px",
              }}
              image={cartPopup.image}
              alt={cartPopup.item}
            />
          </Box>

          {/* Product Details */}
          <Box sx={{ flex: "1" }}>
            <Typography
              sx={{ fontSize: "14px", fontWeight: "bold", marginBottom: "8px" }}
            >
              {cartPopup.count} {cartPopup.count > 1 ? "Item(s)" : "Item"} added
              to cart
            </Typography>
            {typeof cartPopup.price === "number" && (
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  marginBottom: "8px",
                }}
              >
                Total Price: ₹{cartPopup.price.toFixed(2)}
              </Typography>
            )}
          </Box>

          {/* Go to Cart Button */}
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#ff5722",
              color: "#fff",
              fontWeight: "bold",
              textTransform: "none",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#e64a19",
              },
            }}
            onClick={() => navigate("/cart")}
          >
            Go to Cart
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ListingProductList;
